import { useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../context/firebase';

export default function useContent(target) {
  const [content, setContent] = useState([]);
  const { firebase } = useContext(FirebaseContext);

  useEffect(() => {
    let isMounted = true;
    firebase
      .firestore()
      .collection(target)
      .get()
      .then((snapshot) => {
        const allContent = snapshot.docs.map((contentObj) => ({
          ...contentObj.data(),
          docId: contentObj.id,
        }));

        // Remove duplicates
        const uniqueContent = [...new Set(allContent.map(item => JSON.stringify(item)))].map(item => JSON.parse(item));

        if (isMounted) {
          setContent(uniqueContent);
        }
      })
      .catch((error) => {
        console.log(error.message);
      });

    return () => {
      isMounted = false;
    };
  }, [firebase, target]);

  return { [target]: content };
}